import type { BackofficeContext } from "../context/types";
import type { EntityView } from "../view/types";

export interface SectionConfig {
  name: string;
  /** i18n translation key for this section's label. */
  title: string;
  position?: number;
}

export interface EntityConfig {
  id: string;
  name: string;
  /** i18n translation key for this entity's label. */
  title: string;
  position?: number;
  create: (ctx: BackofficeContext) => EntityView;
}

export type NodeConfig = SectionConfig | EntityConfig;

export interface RegistryNode {
  segment: string;
  path: string;
  config: NodeConfig;
  children: RegistryNode[];
}

export const isEntityConfig = (config: NodeConfig): config is EntityConfig =>
  "create" in config && typeof (config as EntityConfig).create === "function";

export const isSectionConfig = (config: NodeConfig): config is SectionConfig =>
  !isEntityConfig(config);
